
import "./src/css/fonts/Bebas/style.css";
import "./src/css/preloader/preloader.scss";
import "./src/css/icons/fonts/icomoon/style.css";
import "./src/css/icons/share/style.css";
import "./src/css/global.css";
import "typeface-roboto";

export const onInitialClientRender = () => {
    setTimeout(function() {
        document.getElementById("preloader").style.display = "none";
    }, 1000)
}